import { Button, Flex, Image, Text } from "@fluentui/react-northstar";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import Sharepoint from "../../../../assets/illustrations/offboarding/Sharepoint.svg";

export const UserDetailContract = ({ user }) => {
    const startDate = user?.arrival_date;

    const DateNumber = moment(startDate).format("DD");
    const MonthYear = moment(startDate).format("MMM.YYYY");

    return (
        <Flex column gap="gap.large">
            <MainCard>
                <Flex styles={{ gap: "16px" }} column>
                    <TitleCard content="Contrat" />
                    <FirstLine vAlign="center">
                        <PurpleFlex column>
                            <PurpleText content={DateNumber} />
                            <MonthText content={MonthYear} />
                        </PurpleFlex>
                        <Flex column>
                            <SecondaryText content="Ancienneté" />
                            <Text content={user?.seniority?.seniority_text} />
                        </Flex>
                    </FirstLine>
                    <FirstLine vAlign="center">
                        <Flex column>
                            <SecondaryText content="Fin de la période d'essai" />
                            <Text
                                content={moment(
                                    user?.probationary_period_end_date
                                ).format("DD/MM/YYYY")}
                            />
                        </Flex>
                        <Flex column>
                            <SecondaryText content="Fin de contrat" />
                            <Text
                                content={moment(user?.departure_date).format(
                                    "DD/MM/YYYY"
                                )}
                            />
                        </Flex>
                    </FirstLine>
                </Flex>
            </MainCard>
            <Flex column gap="gap.medium">
                <Flex column gap="gap.smaller">
                    <SecondaryText content="Type de motif" />
                    <Text
                        content={user?.reason ? user?.reason : "Pas de raison "}
                    />
                </Flex>
                <Flex column gap="gap.smaller">
                    <SecondaryText content="Description" />
                    {user?.reason_description ? (
                        <Text content={user?.reason_description} />
                    ) : (
                        <Text
                            styles={{ fontStyle: "italic" }}
                            content={"Aucune description saisie"}
                        />
                    )}
                </Flex>
            </Flex>
            <Flex fill hAlign="center">
                <Button
                    disabled={!user?.sharepoint_url}
                    onClick={() => window.open(user?.sharepoint_url, "_blank")}
                    icon={<Image src={Sharepoint} />}
                    content="Accéder aux documents"
                />
            </Flex>
        </Flex>
    );
};

const MainCard = styled(Flex)`
    padding: 24px;
    margin-top: 16px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
        0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);
`;

const TitleCard = styled(Text)`
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

const PurpleFlex = styled(Flex)`
    border-radius: 2px;
    background: #e8ebfa;
    padding: 8px 12px;
    width: 130px;
    gap: 4px;
`;

const SecondaryText = styled(Text)`
    color: #616161;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const FirstLine = styled(Flex)`
    gap: 56px;
`;

const PurpleText = styled(Text)`
    color: #4f52b2;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
`;
const MonthText = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
`;
